<template>
    <div v-if="backdrop">
        <div class="modal fade" :class="modal.open ? 'show' : ''" style="display: block" tabindex="-1" role="dialog"
            aria-hidden="true" @click="$event.target.classList.contains('modal') ? close() : true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ config.title == null ? '&nbsp;' : config.title }}</h5>
                        <button type="button" class="close" @click="close()" v-html="ic('close')" />
                    </div>

                    <div class="modal-body text-center border">
                        <div class="page-body">
                            <div class="frame-upload" @dragover.prevent @drop.prevent="_drop">
                                <div class="input-file" :class="condition.isSubmit ? 'active' : ''">
                                    <input type="file" class="form-control" accept=".xlsx,.xls" ref="file"
                                        @change="_onFile" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer pt-2 d-flex justify-content-between">
                        <button 
                            type="button"
                            class="btn btn-outline-primary" 
                            @click="downloadTemplate"
                            v-html="ic('download') + 'Template'">
                        </button>

                        <button type="submit" class="btn btn-primary" 
                            @click="submit"
                            :disabled="isSubmit" 
                            v-html="isSubmit ? spin() : 'Import'">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
    name: "FormImport",
    props: {
        config: {
            default: {
                view: false,
                title: "Modal Title"
            }
        },
        initData: null,
        isSubmit: { default: false },
        dismiss: { default: true }
    },

    mixins: [helper],

    data() {
        return {
            backdrop: false,
            modal: {
                open: false,
                formNav: 0
            },
            request: true,
            file: {
                data: null
            },
            condition: {
                hasUploaded: false,
                isSubmit: false,
                isFinish: false,
            },
            form: {
                time: 0,
                loading: false,
                isSubmit: false,
                timeFinish: 0,
                interval: null,
                allowed: ["xlsx", "xls"],
            }
        };
    },

    methods: {
        close() {
            this.$emit("update:config", { view: false });
        },
        downloadTemplate(){
            this.$emit('template');
        },

        submit() {
            if (this.condition.hasUploaded == false) {
                this.toast('Anda belum memilih file apapun.')
            } else {
                let importData = new FormData()
                importData.append('file', this.file.data);
                this.$emit('update:isSubmit', true)
                this.$emit('submit', importData);
            }
        },

        _drop(event) {
            this._onFile(event, { files: event.dataTransfer.files })
        },

        _onFile(event, params) {
            const file = params == null ? event.target.files[0] : params.files[0];
            if (this.form.allowed.indexOf(file.name.split(".").pop()) < 0) {
                this.toast("Format file tidak valid");
                return;
            }
            this.file.data = file;
            this.condition.hasUploaded = true
        }
    },

    watch: {
        "config.view": function (view) {
            if (view) {
                this.$emit("update:isSubmit", false);

                this.backdrop = true;
                setTimeout(() => {
                    this.modal.open = view;
                }, 100);
            } else {
                this.modal.open = view;

                setTimeout(() => {
                    this.backdrop = view;
                }, 100);
            }
        },

        initData: function (data) {
            Object.assign(this.$data.file, this.$options.data.call(this).file);

            if (data.gambar != null) this.file.url = data.gambar
        },

    }
};
</script>
